import React from "react"
import { Flex, Mosaic, InfoTile, Button } from "@capioweb/ui-components/src"
import { BlockCommonLayout } from "../../utils/layout"
import {
	StringProperty,
	NumberProperty,
	LinkProperty,
} from "../../@types/EpiFoundationSpa/Property"
import { assetBaseUrl, imageBlockDataToImageProps } from "../../utils"
import { LocalesContext } from "../../context"
import { QBankImage } from "../../@types/CapioWeb/core"

interface CapioAboutUsBlockProps {
	heading: StringProperty
	linkItem: LinkProperty
	preamble: StringProperty
	keyValue1: NumberProperty
	keyValue2: NumberProperty
	keyValue3: NumberProperty
	keyText1: StringProperty
	keyText2: StringProperty
	keyText3: StringProperty
	image1: QBankImage
	image2: QBankImage
	image3: QBankImage
	keyFigureGif1: string
	keyFigureGif2: string
	keyFigureGif3: string
}

const CapioAboutUsBlock: React.FC<CapioAboutUsBlockProps> = (props) => {
	const { translate, translationKeys } = React.useContext(LocalesContext)
	const scrollToTop = React.useCallback(() => {
		window.scroll({ top: 0, left: 0, behavior: "smooth" })
	}, [])

	const srcSetSizes = [{ width: 800, breakpoint: 2560 }]
	return (
		<BlockCommonLayout
			heading={props.heading}
			description={props.preamble}
			link={props.linkItem}
		>
			<Mosaic>
				<InfoTile
					backgroundColor="blue11"
					value={props.keyValue1?.value}
					description={props.keyText1?.value}
					icon={assetBaseUrl() + props.keyFigureGif1}
				/>
				<InfoTile
					backgroundColor="green33"
					value={props.keyValue2?.value}
					description={props.keyText2?.value}
					icon={assetBaseUrl() + props.keyFigureGif2}
				/>
				<InfoTile
					backgroundColor="purple33"
					value={props.keyValue3?.value}
					description={props.keyText3?.value}
					icon={assetBaseUrl() + props.keyFigureGif3}
				/>
				{props.image1 && (
					<img
						{...imageBlockDataToImageProps(
							props.image1,
							true,
							true,
							srcSetSizes
						)}
					/>
				)}
				{props.image2 && (
					<img
						{...imageBlockDataToImageProps(
							props.image2,
							true,
							true,
							srcSetSizes
						)}
					/>
				)}
				{props.image3 && (
					<img
						{...imageBlockDataToImageProps(
							props.image3,
							true,
							true,
							srcSetSizes
						)}
					/>
				)}
			</Mosaic>
			<Flex mt={4}>
				<Button
					variant="ghost"
					icon="arrow-up"
					textColor="navy"
					onClick={() => scrollToTop()}
				>
					{translate(translationKeys.toPageTop)}
				</Button>
			</Flex>
		</BlockCommonLayout>
	)
}

export { CapioAboutUsBlock }
